<template>
  <div>
  <v-alert
                class="mb-6 mx-4 mt-6"
                colored-border
                elevation="2"
                type="info"
            >
              If given Trainee does not exist, Please make sure the trainee is
              registered here.
              <span class="mx-4">
                <!-- <a href>http://ihris.sandboxaddis.com</a>
        <b>OR</b> -->
                <v-btn
                    class="
                    bg-gray-200
                    hover:bg-blue-700
                    text-black
                    font-light
                    py-2
                    px-4
                    rounded
                    focus:outline-none
                    focus:shadow-outline
                  "
                    type="button"
                    @click="goToTraineeHistory"
                >Go to Trainee History</v-btn
                >
              </span>
            </v-alert>
            <v-toolbar
                v-if="canCreateTrainee"
                class="
                headline
                font-weight-regular
                blue-grey
                white--text
                mb-6
                mx-4
                mt-6
              "
                dark
            >
              <v-toolbar-title>Assign Course</v-toolbar-title>
              <v-autocomplete
                  v-model="newTraineesSelect"
                  :items="newTraineeItems"
                  :loading="loading"
                  :search-input.sync="newTraineeSearch"
                  class="mx-4"
                  clearable
                  flat
                  hide-details
                  hide-no-data
                  hide-selected
                  item-text="fullName"
                  label="Search trainee using first, middle, last name, phone number"
                  no-filter
                  prepend-icon="mdi-database-search"
                  return-object
                  solo-inverted
              ></v-autocomplete>
            </v-toolbar>
            <template>
              <v-dialog v-model="newTraineeCourseDialog" persistent width="60%">
                <v-card>
                  <v-card-title
                      class="headline font-weight-regular blue-grey white--text"
                      primary-title
                  >Assign New Trainee Course

                    <v-spacer></v-spacer>

                    <v-btn color="white" text @click="closeDialog(true)">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-card-title
                  >
                  <v-divider></v-divider>
                  <HrdUpdateNewTrainee
                      v-if="newTraineeCourseDialog"
                      :newTrainee="newTrainee"
                      @close="newTraineeCourseDialog = false"
                      @registerOrUpdateNewTrainee="registerOrUpdateNewTrainee"
                  ></HrdUpdateNewTrainee>
                </v-card>
              </v-dialog>
            </template>
            <template>
              <v-dialog v-model="newTCourseDetailDialog" persistent width="60%">
                <v-card>
                  <v-card-title
                      class="headline font-weight-regular blue-grey white--text"
                      primary-title
                  >{{ title }}

                    <v-spacer></v-spacer>

                    <v-btn color="white" text @click="closeDialog(true)">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-card-title
                  >
                  <v-divider></v-divider>
                  <HrdNewTraineeDetail
                      v-if="newTCourseDetailDialog"
                      :newTrainee="newTrainee"
                      :traineStatusIds="traineStatusIds"
                      :traineeStatus="traineeStatus"
                      @close="newTCourseDetailDialog = false"
                  ></HrdNewTraineeDetail>
                </v-card>
              </v-dialog>
            </template>
            <v-card class="mx-4" flat>
              <v-card-title>
                New Trainees Courses
                <br/>
                <v-layout align-self-center class="p-3" row wrap>
                  <v-flex class="p-2" xs2>
                    <v-menu ref="startMenu" v-model="startMenu" :close-on-content-click="false" max-width="290px"
                            min-width="290px" offset-y transition="scale-transition">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field v-model="startDate" :clearable="true" label="Pick start date"
                                      persistent-hint prepend-icon="mdi-calendar" v-bind="attrs" v-on="on"></v-text-field>
                      </template>
                      <v-date-picker
                          ref="startDate" v-model="startDate"
                          :max="endDate ? endDate : null" no-title scrollable
                          @input="startMenu = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex class="p-2" xs2>
                    <v-menu ref="endMenu" v-model="endMenu" :close-on-content-click="false" :return-value.sync="date"
                            min-width="290px" offset-y transition="scale-transition">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field v-model="endDate" :clearable="true" label="Pick end date" prepend-icon="event"
                                      readonly v-bind="attrs" v-on="on"></v-text-field>
                      </template>
                      <v-date-picker v-model="endDate" :min="startDate" no-title
                                     scrollable @input="endMenu = false">
                      </v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex class="p-2" xs2>
                    <v-autocomplete
                        v-model="categoryId"
                        :clearable="true"
                        :items="CATEGORIES"
                        :loading="categoryLoading"
                        item-text="name"
                        item-value="id"
                        label="Cpd activity Category">
                    </v-autocomplete>
                  </v-flex>
                  <v-flex class="p-2" xs2>
                    <v-autocomplete
                        v-model="cpdActivityId"
                        :clearable="true"
                        :items="CPD_ACTIVITIES"
                        :loading="cpdActLoading"
                        item-text="name"
                        item-value="id"
                        label="Cpd activity">
                    </v-autocomplete>
                  </v-flex>
                  <v-flex class="p-2" xs2>
                    <v-autocomplete
                        v-model="statusValue"
                        :clearable="true"
                        :items="STATUS"
                        item-text="name"
                        item-value="id"
                        label="Status">
                    </v-autocomplete>
                  </v-flex>
                  <v-flex class="p-2" xs2>
                    <v-text-field
                        v-model="filterTrainee"
                        append-icon="mdi-magnify"
                        hide-details
                        label="Search"
                        single-line
                    ></v-text-field>
                  </v-flex>
                  <v-spacer></v-spacer>
                  <v-flex class="p-2" xs2 v-if="showSelect && checkUser">
                    <v-btn
                          class="teal white--text"
                          color="primary"
                          dark
                          depressed
                          small
                          @click="handleApprove"
                    >
                        <v-icon left>mdi-check-circle</v-icon>
                        <span>Approve</span>
                      </v-btn>
                  </v-flex>
                </v-layout>
              </v-card-title>
              <v-data-table
                  :headers="newTraineeheaders"
                  :items="newTrainees.rows"
                  :loading="newTraineeLoading"
                  :options.sync="options"
                  :server-items-length="newTrainees.count"
                  class="elevation-1"
                  loading-text="Loading... please wait"
                  :show-select="showSelect && checkUser"
                  v-model="selected"
              >
                <template v-slot:[`item.trainee.fullName`]="{ item }">
                  <label for="item">
                    {{
                      item.trainee
                          ? item.trainee.prefix
                              ? item.trainee.prefix
                              : ""
                          : ""
                    }}
                    {{
                      item.trainee
                          ? item.trainee.firstName
                              ? item.trainee.firstName
                              : "-"
                          : "-"
                    }}
                    {{
                      item.trainee
                          ? item.trainee.middleName
                              ? item.trainee.middleName
                              : "-"
                          : "-"
                    }}
                    {{
                      item.trainee
                          ? item.trainee.lastName
                              ? item.trainee.lastName
                              : "-"
                          : "-"
                    }}</label
                  >
                </template>
                <template v-slot:[`item.trainee.gender`]="{ item }">
                  <label for="item">{{
                      item.trainee
                          ? item.trainee.gender
                              ? item.trainee.gender
                              : "-"
                          : "-"
                    }}</label>
                </template>
                <template v-slot:[`item.trainee.phoneNumber`]="{ item }">
                  <label for="item">{{
                      item.trainee
                          ? item.trainee.phoneNumber
                              ? item.trainee.phoneNumber
                              : "-"
                          : "-"
                    }}</label>
                </template>
                <template v-slot:[`item.trainee.healthProfession`]="{ item }">
                  <label for="item">{{
                      item.trainee
                          ? item.trainee
                              ? item.trainee.healthProfession
                                  ? item.trainee.healthProfession.name
                                  : "-"
                              : "-"
                          : "-"
                    }}</label>
                </template>

                <template v-slot:[`item.actions`]="{ item }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon
                          class="mr-2"
                          style="color: teal"
                          @click="viewNewTrainee(item)"
                          v-on="on"
                      >mdi-eye
                      </v-icon
                      >
                    </template>
                    <span>View New Trainee</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-if="canEditTrainee(item?.new_trainees_course?.traineeStatusId ??
                    item?.newt_cat2_course?.traineeStatusId ?? null)" v-slot:activator="{ on }">
                      <v-icon
                          class="mr-2"
                          style="color: teal"
                          @click="editNewTrainee(item)"
                          v-on="on"
                      >mdi-circle-edit-outline
                      </v-icon
                      >
                    </template>
                    <span>Edit New Trainee</span>
                  </v-tooltip>
                </template>
              </v-data-table>
            </v-card>
  </div>
</template>

<script>
import {TraineeService} from "../trainees.service";
import HrdUpdateNewTrainee from "./hrd-update-new-trainee.vue";
import HrdNewTraineeDetail from "./hrd-new-trainee-detail.vue";

import {getCategories, getProgramsDrp, getUser} from "@/utils/helper";
import {getUserRole} from "../../../utils/helper";

export default {
  props: {
    fromRoute: String,
  },
  components: {
    HrdUpdateNewTrainee,
    HrdNewTraineeDetail,
  },
  data() {
    return {
      CATEGORIES: [],
      CPD_ACTIVITIES: [],
      STATUS: [],
      cpdActLoading: false,
      categoryLoading: false,
      statusLoading: false,

      startDate: null,
      endDate: null,
      cpdActivityId: null,
      categoryId: null,
      statusValue: null,
      filterTrainee: null,

      loading: false,
      selected: false,
      items: [],
      title: "",
      options: {
        page: 1,
        itemsPerPage: 10,
      },
      entries: [],
      cpdActivity: null,
      search: null,
      startMenu: false,
      newTraineeStartMenu: null,
      newTraineeEndMenu: null,
      date: '',
      newTraineesSearch: '',
      newTraineeStartDate: '',
      endMenu: false,
      newTraineeEndDate: '',
      searchTrainee: null,
      select: null,
      dialog: false,
      detailDialog: false,
      traineeNotFound: false,
      traineStatusIds: {passId: "", failId: ""},
      traineeStatus: [],
      headers: [
        {text: "Full Name", value: "person.fullName"},
        {text: "Gender", value: "person.gender"},
        // { text: "Birth Date", value: "person.birthdate" },
        // {
        //   text: "Profession",
        //   value: "person.employee_job_history.jobtitlename",
        // },
        {text: "License Number", value: "person.licenseNumber"},
        {text: "Tin Number", value: "person.tin"},
        {text: "Actions", value: "actions", sortable: false, align: "center"},
      ],
      export_fields: {
        "First Name": "person.firstname",
        "Middle Name": "person.middlename",
        "Last Name": "person.lastname",
        Gender: "person.gender",
        // eslint-disable-next-line no-constant-condition
        "Course Name": "trainee_course" ? ("trainee_course.course" ? "trainee_course.course.courseName" : " ") : ("trainee_cat2_course.program" ? "trainee_cat2_course.program.courseTitleCat2" : " "),
        // eslint-disable-next-line no-constant-condition
        CEU: "trainee_course" ? ("trainee_course.course" ? "trainee_course.course.continualEducationUnit" : " ") : ("trainee_cat2_course.program" ? "trainee_cat2_course.program.ceu" : " "),
      },
      export_new_trainee_fields: {
        "First Name": "trainee.firstName",
        "Middle Name": "trainee.middleName",
        "Last Name": "trainee.lastName",
        phoneNumber: "trainee.phoneNumber",
        // eslint-disable-next-line no-constant-condition
        "Course Name": "new_trainees_course" ? ("new_trainees_course.course" ? "new_trainees_course.course.courseName" : " ") : ("newt_cat2_course.program" ? "newt_cat2_course.program.courseTitleCat2" : " "),
        // eslint-disable-next-line no-constant-condition
        CEU: "new_trainees_course" ? ("new_trainees_course.course" ? "new_trainees_course.course.continualEducationUnit" : " ") : ("newt_cat2_course.program" ? "newt_cat2_course.program.ceu" : " "),
      },
      trainees: [],
      showTable: false,
      trainee: null,
      tab: null,
      tabItems: ["Trainees from HRA", "Newly Registered Trainees"],
      newTraineesSelect: null,
      newTraineeCourseDialog: false,
      newTraineeNotFound: false,
      newTrainee: null,
      newTraineeItems: [],
      newTrainees: [],
      newTraineeSearch: null,
      searchNewTrainee: null,
      newTCourseDetailDialog: false,
      newTraineeheaders: [
        {text: "Full Name", value: "trainee.fullName"},
        {text: "Phone Number", value: "trainee.phoneNumber"},
        {text: "Gender", value: "trainee.gender"},
        {
          text: "Profession",
          value: "trainee.healthProfession.name",
        },
        {text: "Actions", value: "actions", sortable: false, align: "center"},
      ],
      historyLoading: false,
      newTraineeLoading: false,

      checkUser: false,
      showSelect: false,
    };
  },
  watch: {
    search(val) {
      if (this.select && this.items.length > 0) return;
      val && val !== this.select && this.querySelections(val);
      if (val === null) {
        this.traineeNotFound = false;
      }
    },
    options: {
      handler() {
        this.fetchNewTraineeCourseList();
      },
      deep: true,
    },
    //
    filterTrainee: function (val) {
      this.filterTrainee = val;
      this.fetchNewTraineeCourseList();
    },
    startDate: function (val) {
      this.startDate = val;
      this.fetchNewTraineeCourseList();
    },
    endDate: function (val) {
      this.endDate = val;
      this.fetchNewTraineeCourseList();
    },
    categoryId: function (val) {
      this.categoryId = val;
      this.fetchCpdActivity(this.categoryId);
      this.fetchNewTraineeCourseList();
    },
    cpdActivityId: function (val) {
      this.cpdActivityId = val;
      this.fetchNewTraineeCourseList();
    },
    statusValue: function (val) {
      this.statusValue = val;
      if(this.statusValue===3){
        this.showSelect=true;
      }else{
        this.showSelect=false;
      }
      this.fetchNewTraineeCourseList();
    },
    online: function (val) {
      this.online = val;
      this.fetchNewTraineeCourseList();
    },
    //

    newTraineesSearch: function (val) {
      this.newTraineesSearch = val;
      this.fetchNewTraineeCourseList();
    },
    newTraineeStartDate: function (val) {
      if (val == null) {
        this.newTraineeStartDate = ''
      } else {
        this.newTraineeStartDate = val;
        this.fetchNewTraineeCourseList();
      }
    },
    newTraineeEndDate: function (val) {
      if (val == null) {
        this.newTraineeEndDate = ''
      } else {
        this.newTraineeEndDate = val;
        this.fetchNewTraineeCourseList();
      }
    },
    select(val) {
      val != null
          ? ((this.dialog = true),
              (this.traineeNotFound = false),
              (this.trainee = val))
          : (this.dialog = false);

      this.dialog == true ? (this.title = "Assign Trainee Course") : null;
    },
    newTraineeSearch(val) {
      if (this.newTraineesSelect && this.newTraineeItems.length > 0) return;
      val &&
      val !== this.newTraineesSelect &&
      this.newTraineeQuerySelections(val);
      if (val === null) {
        this.newTraineeNotFound = false;
      }
    },
    newTraineesSelect(val) {
      val != null
          ? ((this.newTraineeCourseDialog = true),
              (this.newTraineeNotFound = false),
              (this.newTrainee = val))
          : (this.newTraineeCourseDialog = false);
    },
  },
  computed: {
    fields() {
      if (!this.select) return [];

      return this.select;
    },
    canCreateTrainee() {
      return getUser().permissions.some(
          (permission) =>
              permission.menuItem.menuItemName == "Trainee" && permission.canCreate
      );
    },
    // canEditTrainee() {
    //   return getUser().permissions.some(
    //       (permission) =>
    //           permission.menuItem.menuItemName == "Trainee" && permission.canUpdate
    //   );
    // },
    canViewTrainee() {
      return getUser().permissions.some(
          (permission) =>
              permission.menuItem.menuItemName == "Trainee" && permission.canRead
      );
    },
  },
  async beforeMount() {
    if (this.fromRoute === "Back") {
      this.tab = 0;
    } else if (this.fromRoute === "Add") {
      this.tab = 1;
    } else {
      this.tab = 0;
    }
    this.initLookups();

    this.userRole = getUserRole();
    // eslint-disable-next-line no-constant-condition
    if(this.userRole === 'System admins' || 'CPD Director'){
      this.checkUser = true;
    }
  },
  methods: {
    async handleApprove() {
      const trainee = this.selected.map((e) => {
        return {id:e.id, category:e.trainee_cat2_course ? 'cat2' : 'cat1'};
      });
      await TraineeService.approveTrainees('hra', {trainee});
    },

    async initLookups() {
      this.categoryLoading = true;
      this.CATEGORIES = await getCategories();
      this.categoryLoading = false;

      this.fetchCpdActivity();
      this.fetchNewTraineeCourseList();
      this.fetchTraineeStatus();
    },
    async fetchCpdActivity(id = null) {
      this.cpdActLoading = true;
      const programs = await getProgramsDrp(id);
      this.CPD_ACTIVITIES = programs.data;
      this.cpdActLoading = false;
    },
    canEditTrainee(item) {
      return !item && (getUser().permissions.some(
          (permission) =>
              permission.menuItem.menuItemName == "Trainee" && permission.canUpdate
      ));
    },
    formatDate(item) {
      const date = new Date(item.birthdate);
      return date;
    },
    viewTrainee(item) {
      this.trainee = item;
      this.detailDialog = true;
      this.title = "Trainee's Course Detail";
    },
    viewNewTrainee(item) {
      this.newTrainee = item;
      this.newTCourseDetailDialog = true;
      this.title = "New Trainee's Course Detail";
    },
    goToTraineeRegistration() {
      this.$router.push({
        path: "/registerTrainee",
        name: "Register Trainee",
        params: {fromRoute: "Add"},
      });
    },
    goToTraineeHistory() {
      this.$router.push({
        path: "/registerTrainee",
        name: "Register Trainee",
        params: {fromRoute: "History"},
      });
    },
    closeDialog(isNewTrainee) {
      this.detailDialog = false;
      this.newTraineeCourseDialog = false;
      this.newTCourseDetailDialog = false;
      this.dialog = false;
      isNewTrainee ? this.fetchNewTraineeCourseList() : this.fetchTraineeList();
    },
    async querySelections(v) {
      this.loading = true;
      const params = {
        value: v,
      };
      const res = await TraineeService.searchTrainee(params);

      if (res.status === 200) {
        this.loading = false;
        this.items = res.data;

        if (v != null && this.items.length === 0) {
          this.traineeNotFound = true;
        }

        this.items.map((item) => {
          item.fullName =
              item.firstname + " " + item.middlename + " " + item.lastname;
        });
        return this.items;
      } else {
        this.loading = false;

        return this.items;
      }
    },
    async newTraineeQuerySelections(v) {
      this.loading = true;
      const params = {
        value: v,
      };
      const res = await TraineeService.searchNewTrainee(params);

      if (res.status === 200) {
        this.loading = false;
        this.newTraineeItems = res.data;

        if (v != null && this.newTraineeItems.length === 0) {
          this.newTraineeNotFound = true;
        }

        this.newTraineeItems.map((item) => {
          item.fullName =
              item.firstName + " " + item.middleName + " " + item.lastName;
        });
        return this.newTraineeItems;
      } else {
        this.loading = false;

        return this.newTraineeItems;
      }
    },
    async registerOrUpdateTrainee(trainee) {
      this.historyLoading = true;
      let res = null;

      if (trainee.editMode) {
        res = await TraineeService.update(trainee.id, trainee);

        if (res.status === 201) {
          switch (res.data.status) {
            case 200:
              this.$toast.success(res.data.message);
              this.fetchTraineeList();
              break;
            case 500:
              this.$toast.error(res.data.message);
              break;
          }
          this.historyLoading = false;
        } else {
          this.historyLoading = false;
          this.$toast.error("Unable to create trainee, please try again");
        }
      } else {
        res = await TraineeService.create(trainee);

        if (res.status === 200) {
          switch (res.data.status) {
            case 200:
              this.$toast.success(res.data.message);
              this.fetchTraineeList();
              break;
            case 500:
              this.$toast.error(res.data.message);
              break;
          }
          this.historyLoading = false;
        } else {
          this.historyLoading = false;
          this.$toast.error("Unable to create trainee, please try again");
        }
      }
    },
    async registerOrUpdateNewTrainee(trainee) {
      let res = null;

      if (trainee.editMode) {
        res = await TraineeService.updateNewTraineeCourse(trainee.id, trainee);

        if (res.status === 201) {
          switch (res.data.status) {
            case 200:
              this.$toast.success(res.data.message);
              this.fetchNewTraineeCourseList();
              break;
            case 500:
              this.$toast.error(res.data.message);
              break;
          }
        } else {
          this.$toast.error("Unable to create trainee, please try again");
        }
      } else {
        res = await TraineeService.createNewTraineeCourse(trainee);

        if (res.status === 200) {
          switch (res.data.status) {
            case 200:
              this.$toast.success(res.data.message);
              this.fetchNewTraineeCourseList();
              break;
            case 500:
              this.$toast.error(res.data.message);
              break;
          }
        } else {
          this.$toast.error("Unable to create trainee, please try again");
        }
      }
    },
    refreshTraineeDetail() {
      this.fetchTraineeList();
      this.fetchNewTraineeCourseList();
      this.fetchTraineeStatus();
    },
    async fetchTraineeStatus() {
      this.traineeStatus = await TraineeService.getTraineeStatus();
      this.STATUS = [...this.traineeStatus.data, {name: 'Un Completed', id: 0}];
      this.traineeStatus.data.filter((e) => {
        this.traineStatusIds.passId =
            e.code == "PASS" ? e.id : this.traineStatusIds.passId;
        this.traineStatusIds.failId =
            e.code == "FAIL" ? e.id : this.traineStatusIds.failId;
      });
    },
    async fetchTraineeList() {
      this.historyLoading = true;
      console.log('here')
      // let dates={}
      // this.startDate!==''&&(dates.startDate=this.startDate);
      // this.endDate!==''&&(dates.endDate=this.endDate);

      const {page, itemsPerPage} = this.hraOptions;
      let params = `?page=${page}&pageSize=${itemsPerPage}`;
      // this.nonAccCpd !== null && (searchParams += '&trainingCenterId=' + this.nonAccCpd);
      // this.nonAccName !== null && (searchParams += '&name=' + this.nonAccName);
      const res = await TraineeService.getHraTraineeAssignList(params);
      if (res.status === 200) {
        this.trainees = res.data;
      }
      this.historyLoading = false;
    },
    async fetchNewTraineeCourseList() {
      this.newTraineeLoading = true;
      const {page, itemsPerPage} = this.options;
      let params = `?page=${page}&pageSize=${itemsPerPage}`;
      this.filterTrainee !== null && (params += '&name=' + this.filterTrainee);
      this.startDate !== null && (params += '&startDate=' + this.startDate);
      this.endDate !== null && (params += '&endDate=' + this.endDate);
      this.categoryId !== null && (params += '&categoryId=' + this.categoryId);
      this.cpdActivityId !== null && (params += '&cpdActivityId=' + this.cpdActivityId);
      this.statusValue !== null && (params += '&statusId=' + this.statusValue);

      const res = await TraineeService.getNewTraineeAssignList(params);
      if (res.status === 200) {
        this.newTrainees = res.data;
      }
      this.newTraineeLoading = false;
      // let dates = {}
      // this.newTraineeStartDate !== '' && (dates.startDate = this.newTraineeStartDate)
      // this.newTraineeEndDate !== '' && (dates.endDate = this.newTraineeEndDate)
    },
    editTrainee(item) {
      this.dialog = true;
      this.trainee = item;
      this.title = "Edit Trainee's Course";
    },
    editNewTrainee(item) {
      this.newTraineeCourseDialog = true;
      this.newTrainee = item;
      this.title = "Edit New Trainee's Course";
    },
  },
};
</script>

<style scoped>
.basil {
  background-color: #eff6ff !important;
}

.basil--text {
  color: #356859 !important;
}
</style>
